import { useQuery } from 'react-query';
import { archivosFetch } from '../../../utils/fetch';

// The public verifications that resolved to one document
// (`GET /api/verification-logs?document_id=`, admins only).

export type VerificationEntry = {
  id: string;
  at: string;
  code: string;
  /** Scanned QR code, or the public verification page. */
  channel: 'scan' | 'page';
  /** "iPhone · Safari", or null when the browser said nothing recognisable. */
  device: string | null;
};

type VerificationPage = {
  entries: VerificationEntry[];
  totalItems: number;
};

type Params = {
  documentId: string;
  page: number;
  pageSize: number;
};

const fetchEntries = async ({
  documentId,
  page,
  pageSize,
}: Params): Promise<VerificationPage> => {
  const params = new URLSearchParams({
    document_id: documentId,
    page: String(page + 1),
    limit: String(pageSize),
  });

  const response = await archivosFetch(
    `${process.env.REACT_APP_API_URL}/api/verification-logs?${params}`,
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  const body = await response.json();
  return {
    entries: Array.isArray(body?.entries) ? body.entries : [],
    totalItems: typeof body?.totalItems === 'number' ? body.totalItems : 0,
  };
};

export const useVerificationHistory = (params: Params) => {
  const { documentId, page, pageSize } = params;

  return useQuery<VerificationPage, Error>(
    ['VERIFICATION_HISTORY', documentId, page, pageSize],
    () => fetchEntries(params),
    { keepPreviousData: true, retry: false },
  );
};
